'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRedux = require('react-redux');
var _reduxForm = require('redux-form');
var _ramda = require('ramda');
var _reduxPagan = require('redux-pagan');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _reactIntlTelInput = require('react-intl-tel-input');var _reactIntlTelInput2 = _interopRequireDefault(_reactIntlTelInput);

var _components = require('../../components');

var _userAuthentication = require('../../redux/modules/userAuthentication');







var _LoginButton = require('./LoginButton');var _LoginButton2 = _interopRequireDefault(_LoginButton);
var _ResendButton = require('./ResendButton');var _ResendButton2 = _interopRequireDefault(_ResendButton);
var _ResendLimitExceededMessage = require('./ResendLimitExceededMessage');var _ResendLimitExceededMessage2 = _interopRequireDefault(_ResendLimitExceededMessage);
var _ResendTimer = require('./ResendTimer');var _ResendTimer2 = _interopRequireDefault(_ResendTimer);

var _constants = require('../../constants');
var _validate = require('../../utils/validate');
var _formatPhoneNumber = require('../../utils/formatPhoneNumber');
var _constants2 = require('./constants');
var _validate2 = require('./validate');var _validate3 = _interopRequireDefault(_validate2);

var _loginContainer = require('./loginContainer.scss');var styles = _interopRequireWildcard(_loginContainer);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Redux
// Helper
// Styles
var LoginContainer = function (_Component) {_inherits(LoginContainer, _Component);function LoginContainer() {var _temp, _this, _ret;_classCallCheck(this, LoginContainer);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { doValidate: false, captcha: null,
      countryCode: _constants.israelCode,
      emailIsValid: false,
      phoneIsValid: false,
      isFirstValue: false,
      resendCounter: 0,
      timerTimeLeft: 0,
      isTimerRunning: false,
      isResendForm: false }, _this.






    onSelectFlag = function (_, countryData) {
      _this.setState({ countryCode: countryData.dialCode });
    }, _this.

    setWrapperRef = function (node) {
      _this.formRef = node;
    }, _this.

    getPhoneInputRef = function (ref) {_this.phoneInputRef = ref;}, _this.

    forgotPassword = function () {
      _this.props.openAuthenticationModal({ bodyType: _constants.authenticationModalType.FORGOT_PASSWORD });
    }, _this.

    startTimer = function () {
      clearInterval(_this.resendTimer);
      _this.resendTimer = setInterval(function () {
        _this.setState(function (prevState) {
          if (prevState.timerTimeLeft <= 1) {
            clearInterval(_this.resendTimer);
            return { timerTimeLeft: 0, isTimerRunning: false };
          }
          return { timerTimeLeft: prevState.timerTimeLeft - 1 };
        });
      }, 1000);
    }, _this.

    submitLoginViaPassword = function (values) {
      var email = (0, _get2.default)(values, 'email');
      var password = (0, _get2.default)(values, 'password');
      _this.props.authenticateUser({
        email: email,
        password: password,
        requestType: _constants.userAuthenticationTabs.SIGN_IN });

    }, _this.

    submitLoginViaSms = function (values, isResendForm) {
      var isCheckPhone =
      _this.props.userAuthentication &&
      _this.props.userAuthentication.isCheckPhone;
      var phone = (0, _get2.default)(values, 'phone');
      var code = (0, _get2.default)(values, 'code');var _this$state =
      _this.state,countryCode = _this$state.countryCode,captcha = _this$state.captcha;

      if (!captcha) {
        console.warn('No captcha found');
        return;
      }

      var phoneNumberData = (0, _formatPhoneNumber.formatLoginPhoneNumber)(phone, countryCode);

      if (!isCheckPhone) {
        _this.props.checkPhone({
          phone: phoneNumberData,
          captcha: captcha,
          locale: _this.props.locale });

        _this.setState({
          captcha: null,
          resendCounter: 0,
          isTimerRunning: true,
          timerTimeLeft: 61 });

        _this.startTimer();
      } else if (isResendForm) {
        _this.props.checkPhone({
          phone: phoneNumberData,
          captcha: captcha,
          locale: _this.props.locale });

        _this.setState(function (prevState) {return {
            captcha: null,
            resendCounter: prevState.resendCounter + 1,
            isTimerRunning: prevState.resendCounter < 3,
            timerTimeLeft: prevState.resendCounter < 3 ? 61 : 0 };});

        _this.startTimer();
      } else if (isCheckPhone) {
        _this.props.authenticateUserByNumber({
          phone: phoneNumberData,
          captcha: captcha,
          code: code });

        _this.setState({ captcha: null });
      }
    }, _this.

    submitForm = function (values, isResendForm) {
      if (values.loginType === _constants2.loginType.LOGIN_VIA_SMS) {
        _this.submitLoginViaSms(values, isResendForm);
      } else {
        _this.submitLoginViaPassword(values);
      }
    }, _this.

    handleSubmit = function (evt, isResendForm) {
      _this.setState({ isResendForm: isResendForm });
      _this.props.handleSubmit(function (value) {return _this.submitForm(value, isResendForm);})(evt);
      return true;
    }, _this.

    fetchReCaptchaToken = function (evt, isResendForm) {
      _this.setState({ captcha: evt }, function (value) {return _this.handleSubmit(value, isResendForm);});
    }, _this.

    validationMark = function (isInvalid) {return _this.setState({ showError: isInvalid });}, _this.

    validatePhoneNumber = function () {var phoneNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var number = phoneNumber.toString().replace(/\D/g, '');
      var isValid = !!number && number.length >= 9 && number.length <= 15;
      return !isValid;
    }, _this.

    handleSelectCountry = function (first, countryData) {
      if (_this.state.countryCode !== countryData.dialCode) {
        _this.setState({ countryCode: countryData.dialCode });
      }
    }, _this.

    handlePhoneNumberChange = function (isValid, inputData, countryData, phoneNumber) {
      var onlyNums = inputData.replace(/[^+\d\s-]/g, '');

      var condition = onlyNums && (onlyNums.length >= 9 || onlyNums.length <= 11);

      _this.props.change('phone', onlyNums);

      _this.setState({ phoneIsValid: condition });

      if (_this.state.countryCode !== countryData.dialCode) {
        _this.setState({ countryCode: countryData.dialCode });
      }
    }, _this.

    defineEmailErrorMsg = function () {
      var errorMsg = '';

      if (_this.state.isTemporaryEmail) {
        errorMsg = _this.props.translate('authenticationPage', 'errorMessageForTemporaryUser');
      } else if (!_this.state.emailIsValid) {
        errorMsg = _this.props.translate('authenticationPage', 'emailTooltipMessage');
      } else {var
        error = _this.props.userAuthentication.error;
        errorMsg = error && (error.name === 'BadRequestError' || error.message.match(/email/i)) ?
        _this.props.translate('authenticationPage', 'errorMessage') :
        '';
      }

      return errorMsg.toString();
    }, _this.

    renderButton = function () {
      var withCaptcha = _this.state.emailIsValid || _this.state.phoneIsValid;
      var loadingUserData = _this.props.userAuthentication && _this.props.userAuthentication.loading;var _this$props =
      _this.props,isNative = _this$props.isNative,translate = _this$props.translate;

      return (
        _react2.default.createElement('div', { className: styles.buttonWrapper },

          !isNative && withCaptcha ?
          _react2.default.createElement(_components.GoogleReCaptcha, {
              locale: _this.props.locale,
              fetchToken: _this.fetchReCaptchaToken,
              captchaIdentifier: 'userLoginForm',
              doReset: loadingUserData,
              userAuthentication: true },

            _react2.default.createElement(_LoginButton2.default, {
              onClick: _this.state.captcha && _this.handleSubmit,
              translate: translate,
              isLoading: loadingUserData })) :



          _react2.default.createElement(_LoginButton2.default, {
            onClick: _this.handleSubmit,
            translate: translate,
            isLoading: loadingUserData })));





    }, _this.

    renderResendButton = function () {
      var showCodeField = _this.props.userAuthentication && _this.props.userAuthentication.isCheckPhone;
      if (!showCodeField) {
        return null;
      }

      var withCaptcha = _this.state.captcha;
      var loadingUserData = _this.props.userAuthentication && _this.props.userAuthentication.loading;
      var disabled = _this.state.isTimerRunning || _this.state.resendCounter >= 3 || loadingUserData;var
      translate = _this.props.translate;var _this$state2 =
      _this.state,isTimerRunning = _this$state2.isTimerRunning,resendCounter = _this$state2.resendCounter;

      if (resendCounter >= 3) {
        return (
          _react2.default.createElement(_ResendLimitExceededMessage2.default, { translate: translate }));

      }
      return (
        _react2.default.createElement('div', {
            className: styles.resendContentWrapper },

          resendCounter < 3 && isTimerRunning &&
          _react2.default.createElement(_ResendTimer2.default, { translate: translate, timeLeft: _this.state.timerTimeLeft }),

          _react2.default.createElement('div', { className: styles.buttonWrapper },
            !withCaptcha ?
            _react2.default.createElement(_components.GoogleReCaptcha, {
                locale: _this.props.locale,
                fetchToken: function fetchToken(evt) {return _this.fetchReCaptchaToken(evt, true);},
                captchaIdentifier: 'resendRegistrationForm',
                doReset: loadingUserData,
                userAuthentication: true },

              _react2.default.createElement(_ResendButton2.default, {
                translate: translate,
                disabled: disabled,
                isTimerRunning: isTimerRunning,
                isLoading: loadingUserData,
                onClick: _this.state.captcha && function (evt) {return _this.handleSubmit(evt, true);} })) :



            _react2.default.createElement(_ResendButton2.default, {
              isLoading: loadingUserData,
              disabled: disabled,
              translate: translate,
              isTimerRunning: isTimerRunning,
              onClick: function onClick(evt) {return _this.handleSubmit(evt, true);} }))));





    }, _this.

    renderPhoneInput = function (_ref) {var input = _ref.input,_ref$meta = _ref.meta,error = _ref$meta.error,touched = _ref$meta.touched;return (
        _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.inputPhone, { 'has-error': error && touched }) },
          _react2.default.createElement(_reactIntlTelInput2.default, {
            ref: _this.getPhoneInputRef,
            autoPlaceholder: false,
            isRtl: _this.props.isRtl,
            nationalMode: false,
            onSelectFlag: _this.onSelectFlag,
            containerClassName: (0, _classnames2.default)('intl-tel-input', styles.countrySelect),
            inputClassName: 'form-control phone-input',
            fieldName: 'phone_number',
            value: input.value,
            preferredCountries: _constants.PREFERRED_COUNTRIES,
            onPhoneNumberChange: _this.handlePhoneNumberChange,
            useMobileFullscreenDropdown: false,
            separateDialCode: true })));}, _this.




    renderEmailInput = function () {var _cx;
      var handleChange = function handleChange(evt) {var
        value = evt.target.value;
        var isEmpty = !value || value && value.length === 0;
        var trimmedValue = value ? value.replace(/\s/g, '') : '';

        var emailIsValid = (0, _validate.emailRegexValidation)(trimmedValue);
        var phoneIsValid = (0, _validate.phoneRegexValidation)(trimmedValue);

        _this.setState(function (prev) {return Object.assign({},
          prev, {
            isFirstValue: !!value.length,
            captcha: !phoneIsValid ? null : prev.captcha,
            emailIsValid: isEmpty ? false : emailIsValid,
            phoneIsValid: isEmpty ? false : phoneIsValid });});

      };

      return (
        _react2.default.createElement('div', {
            className: (0, _classnames2.default)((_cx = {}, _cx[
            styles.phoneInput] = _this.state.phoneIsValid || !_this.state.isFirstValue, _cx),
            'form-group'),

            ref: function ref(email) {_this.email = email;} },

          _react2.default.createElement(_components.OMInputField, {
            isForm: true,
            name: 'email',
            type: 'text',
            translate: _this.props.translate,
            placeholder: '' + _this.props.translate('authenticationPage', 'emailFieldPlaceholder'),
            title: _this.defineEmailErrorMsg(),
            showHoverTooltip: false,
            doValidate: _this.state.doValidate,
            isMobile: _this.props.isMobile,
            onChange: handleChange,
            isRtl: _this.props.isRtl,
            validationMark: _this.validationMark,
            showErrorMessageDesktop: true })));



    }, _this.

    renderPasswordInput = function () {return (
        _react2.default.createElement('div', { className: 'form-group' },
          _react2.default.createElement(_components.OMInputField, {
            isForm: true,
            name: 'password',
            type: 'password',
            translate: _this.props.translate,
            placeholder: '' + _this.props.translate('authenticationPage', 'passwordFieldPlaceholder'),
            title: '' + _this.props.translate('authenticationPage', 'passwordTitle'),
            isMobile: _this.props.isMobile,
            hidePasswordTitle: '' + _this.props.translate('authenticationPage', 'hidePassword'),
            revealPasswordTitle: '' + _this.props.translate('authenticationPage', 'revealPassword'),
            isRtl: _this.props.isRtl,
            showErrorMessageDesktop: true })));}, _this.




    renderPropertyTypes = function () {return (
        _react2.default.createElement('div', { className: styles.propTypesBlock },
          _react2.default.createElement(_components.OMRadioButtons, {
            name: 'loginType',
            values: _constants2.loginTypeOptions.map(function (item) {return (
                { value: item.name, label: _this.props.translate('authenticationPage', item.label) });}),
            className: styles.flexWrap })));}, _this.




    renderCodeField = function () {
      var showCodeField = _this.props.userAuthentication && _this.props.userAuthentication.isCheckPhone;

      if (!showCodeField) {
        return null;
      }

      return (
        _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.codeBlock, 'form-group') },
          _react2.default.createElement(_components.OMInputField, {
            isForm: true,
            name: 'code',
            type: 'text',
            maxLength: '6',
            translate: _this.props.translate,
            placeholder: '' + _this.props.translate('authenticationPage', 'tabCode'),
            isMobile: _this.props.isMobile,
            isRtl: _this.props.isRtl,
            validate: function validate(value) {
              if (_this.state.isResendForm && (!value || !value.length)) {
                return undefined;
              }
              return value && value.length === 4 ? undefined : 'length-code';
            },
            validationMark: _this.validationMark,
            onChange: function onChange(evt) {
              var value = evt.target.value;
              evt.target.value = value.replace(/[\D]/g, '');
            } })));



    }, _this.

    renderSocialAuthentication = function () {return (
        _react2.default.createElement('div', { className: styles.socialAuthenticationWrapper },
          _react2.default.createElement(_components.SocialNetworkAuthentication, {
            className: 'UserAuthenticationSocialNetwork',
            isNewDesign: true,
            size: 26,
            translate: _this.props.translate('userAuthentication'),
            socialNetworkAuthentication: _this.props.socialNetworkAuthentication,
            isMobile: _this.props.isMobile })));}, _temp), _possibleConstructorReturn(_this, _ret);}LoginContainer.prototype.componentWillUnmount = function componentWillUnmount() {clearInterval(this.resendTimer);};LoginContainer.prototype.




  render = function render() {var _props =
    this.props,translate = _props.translate,fields = _props.fields,isRtl = _props.isRtl;
    var isLoginViaSms = fields.loginType === _constants2.loginType.LOGIN_VIA_SMS;
    var isLoginViaPassword = fields.loginType === _constants2.loginType.LOGIN_VIA_PASSWORD;

    return (
      _react2.default.createElement('div', { className: styles.container },
        _react2.default.createElement('form', {
            onSubmit: this.handleSubmit,
            ref: this.setWrapperRef },

          isLoginViaSms ?
          _react2.default.createElement(_reduxForm.Field, {
            name: 'phone',
            type: 'text',
            translate: translate,
            isRtl: isRtl,
            component: this.renderPhoneInput,
            validate: this.validatePhoneNumber }) :


          this.renderEmailInput(),

          this.renderPropertyTypes(),
          isLoginViaPassword && this.renderPasswordInput(),
          isLoginViaPassword && _react2.default.createElement('div', { className: styles.forgotPassword },
            _react2.default.createElement('p', { onClick: this.forgotPassword }, translate('authenticationPage', 'forgotPassword'))),

          isLoginViaSms && this.renderCodeField(),
          this.renderButton(),
          isLoginViaSms && this.renderResendButton())));









  };return LoginContainer;}(_react.Component);


LoginContainer.propTypes = {
  translate: _propTypes2.default.func,
  locale: _propTypes2.default.string.isRequired,
  isMobile: _propTypes2.default.bool,
  fields: _propTypes2.default.object,
  userAuthentication: _propTypes2.default.object,
  sendContactUsForm: _propTypes2.default.func,
  openMessageModal: _propTypes2.default.func,
  hideMessageModal: _propTypes2.default.func,
  switchAuthModalType: _propTypes2.default.func,
  userData: _propTypes2.default.object,
  isMessageModalOpen: _propTypes2.default.bool,
  validatePassword: _propTypes2.default.func,
  usage: _propTypes2.default.string,
  isRtl: _propTypes2.default.bool,
  isNative: _propTypes2.default.bool,
  isContactUsModalOpen: _propTypes2.default.bool,
  hideContactUsModal: _propTypes2.default.func,
  authenticateUser: _propTypes2.default.func,
  openAuthenticationModal: _propTypes2.default.func,
  socialNetworkAuthentication: _propTypes2.default.func,
  change: _propTypes2.default.func,
  authenticateUserByNumber: _propTypes2.default.func,
  handleSubmit: _propTypes2.default.func,
  checkPhone: _propTypes2.default.func,
  isPageForRealtor: _propTypes2.default.bool };


var selector = (0, _reduxForm.formValueSelector)('loginForm');

var mapStateToProps = function mapStateToProps(state) {return {
    translate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    locale: state.lang.locale,
    isMobile: state.windowDimentions.isMobile,
    userData: state.userAuthentication.data,
    userAuthentication: state.userAuthentication,
    fields: {
      email: selector(state, 'email'),
      phone: selector(state, 'phone'),
      password: selector(state, 'password'),
      loginType: selector(state, 'loginType') },

    initialValues: {
      loginType: _constants2.loginType.LOGIN_VIA_PASSWORD } };};



var mapDispatchToProps = {
  authenticateUser: _userAuthentication.authenticateUser,
  switchAuthModalType: _userAuthentication.switchAuthModalType,
  openAuthenticationModal: _userAuthentication.openAuthenticationModal,
  checkPhone: _userAuthentication.checkPhone,
  socialNetworkAuthentication: _userAuthentication.socialNetworkAuthentication,
  authenticateUserByNumber: _userAuthentication.authenticateUserByNumber };exports.default =


(0, _ramda.compose)(
(0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps),
(0, _reduxForm.reduxForm)({
  form: 'loginForm',
  validate: _validate3.default }))(

LoginContainer);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/loginContainer/loginContainer.js
// module id = 1257
// module chunks = 0